import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type IGlobalSearchRepository } from '../../business-logic/interfaces/IGlobalSearchRepository'
import { GlobalSearchResult } from '../../value-objects/GlobalSearchResult'
import { GlobalSearchResultItem } from '../../value-objects/GlobalSearchResultItem'
import { mapGlobalSearchResultsApiModel } from '../mappers/mapGlobalSearchResultsApiModel'
import { type GlobalSearchPayload } from '../types/GlobalSearchPayload'
import { type GlobalSearchResponse } from '../types/GlobalSearchResponse'

interface Dependency {
  httpClient: IHttpClient
}

export class GlobalSearchRepository implements IGlobalSearchRepository {
  constructor(private readonly deps: Dependency) {}

  async search(payload: GlobalSearchPayload): Promise<GlobalSearchResult> {
    const response = await this.deps.httpClient.post<GlobalSearchResponse>(
      '/api/v3/global-command/search/',
      payload
    )

    const { data: items, metadata } = response.data
    const mapped = mapGlobalSearchResultsApiModel(items, metadata)

    return new GlobalSearchResult({
      items: mapped.items.map((item) => new GlobalSearchResultItem(item)),
      counts: mapped.counts,
      isTruncated: mapped.isTruncated,
      isUnsupportedQuery: mapped.isUnsupportedQuery,
    })
  }
}
